export default __webpack_public_path__ + "static/media/priority.0fb17c89.wav";